import React from 'react';

/**
 * DeleteSpaceButton component for deleting spaces
 * 
 * @param {Object} props - Component props
 * @param {string} props.spaceType - Type of space ('box', 'shape', or 'entry')
 * @param {number} props.spaceId - ID of the space
 * @param {Function} props.onDelete - Function to call when deleting the space
 * @returns {JSX.Element} DeleteSpaceButton component
 */
const DeleteSpaceButton = ({ spaceType, spaceId, onDelete }) => {
  return (
    <button 
      className="delete-button"
      onClick={(e) => {
        e.stopPropagation();
        onDelete(spaceType, spaceId);
      }}
      title="Delete this space"
    >
      🗑️
    </button>
  );
};

export default DeleteSpaceButton; 